import Component from '../site/Component';

/**
 * Component for tabbed content
 */
export default class Events extends Component {

  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    this.slides = this.element.querySelectorAll(this.elements.slide);
    this.buttons = this.element.querySelectorAll(this.elements.eventsButton);
    this.eventsBreakpoint = this.utils.breakpoints.generateMedia('m', false);
    this.hideButtonClass = 'events__expand-button--hidden';

    this.removeExtraButtons(this.eventsBreakpoint);
    this.eventsBreakpoint.addListener(this.removeExtraButtons);
  }

  /**
   * Remove buttons if no extra events to show
   */
  removeExtraButtons(query) {
    // max number of events to show before show more button needed (by breakpoint)
    this.eventsPerSlide = 4;
    if (! query.matches) {
      this.eventsPerSlide = 2;
    }

    Array.prototype.forEach.call(this.slides, (slide) => {
      const slideButtons = slide.querySelectorAll(this.elements.eventsButton);
      const events = slide.querySelectorAll(this.elements.eventItem);
      if (events.length <= this.eventsPerSlide) {
        Array.prototype.forEach.call(slideButtons, (button) => {
          button.classList.add(this.hideButtonClass);
        });
      }
    });
  }
}
